import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _bulkPlanResult = { item: '_plan' };
var _bulkUpdatePlansRequest = { plans: '_maskedPlan' };
var _bulkUpdatePlansResponse = { results: '_bulkPlanResult' };
var _countPlansRequest = {};
var _countPlansResponse = {};
var _createPlanRequest = { plan: '_plan' };
var _createPlanResponse = { plan: '_plan' };
var _cursorSearch = { aggregations: '_aggregation' };
var _deletePlanRequest = {};
var _deletePlanResponse = {};
var _getPlanRequest = {};
var _getPlanResponse = { plan: '_plan' };
var _maskedPlan = { fieldMask: 'google.protobuf.FieldMask', plan: '_plan' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _options = { planOptions: '_planOptions' };
var _plan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _planOptions = { startDate: 'google.protobuf.Timestamp' };
var _queryPlansRequest = {};
var _queryPlansResponse = { plans: '_plan' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _searchPlansRequest = { search: '_cursorSearch' };
var _searchPlansResponse = { plans: '_plan' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = { plan: '_plan' };
var _updatePlanRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    plan: '_plan',
};
var _updatePlanResponse = { plan: '_plan' };
var _validateOptionsRequest = { options: '_options' };
var _validateOptionsResponse = {};
function resolveWixPricingPlansPlansV3PlanServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-plans/v3',
                destPath: '/v3',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/pricing-plans/v3',
                destPath: '/v3',
            },
        ],
        _: [
            {
                srcPath: '/_api/pricing-plans/v3',
                destPath: '/v3',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/pricing-plans/v3',
                destPath: '/v3',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/pricing-plans',
                destPath: '/v3',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixPricingPlansPlansV3PlanCatalogUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Validates plan options that are part of a catalog item reference referencing a plan. */
export function validateOptions(payload) {
    var _a = serializer(_validateOptionsRequest, { _options: _options, _planOptions: _planOptions }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateOptionsResponse, {}).fromJSON;
    function __validateOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'GET',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanCatalog.ValidateOptions',
            url: resolveWixPricingPlansPlansV3PlanCatalogUrl({
                protoPath: '/v3/plan-options/validate',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateOptions.fromReq = fromReq;
    __validateOptions.__isAmbassador = true;
    return __validateOptions;
}
/** Creates a Plan */
export function createPlan(payload) {
    var _a = serializer(_createPlanRequest, {
        _plan: _plan,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPlanResponse, { _plan: _plan }).fromJSON;
    function __createPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'POST',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.CreatePlan',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPlan.fromReq = fromReq;
    __createPlan.__isAmbassador = true;
    return __createPlan;
}
/** Retrieves a Plan */
export function getPlan(payload) {
    var _a = serializer(_getPlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPlanResponse, { _plan: _plan }).fromJSON;
    function __getPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'GET',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.GetPlan',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/{planId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPlan.fromReq = fromReq;
    __getPlan.__isAmbassador = true;
    return __getPlan;
}
/** Updates a Plan */
export function updatePlan(payload) {
    var _a = serializer(_updatePlanRequest, {
        _plan: _plan,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePlanResponse, { _plan: _plan }).fromJSON;
    function __updatePlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'PATCH',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.UpdatePlan',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/{plan.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePlan.fromReq = fromReq;
    __updatePlan.__isAmbassador = true;
    return __updatePlan;
}
/** Updates multiple Plans in a single request. Works synchronously. Does not support updating the `name` field. */
export function bulkUpdatePlans(payload) {
    var _a = serializer(_bulkUpdatePlansRequest, { _maskedPlan: _maskedPlan, _plan: _plan }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdatePlansResponse, {
        _bulkPlanResult: _bulkPlanResult,
        _plan: _plan,
    }).fromJSON;
    function __bulkUpdatePlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'POST',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.BulkUpdatePlans',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/bulk/plans/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdatePlans.fromReq = fromReq;
    __bulkUpdatePlans.__isAmbassador = true;
    return __bulkUpdatePlans;
}
/** Deletes a Plan */
export function deletePlan(payload) {
    var _a = serializer(_deletePlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deletePlanResponse, {}).fromJSON;
    function __deletePlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'DELETE',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.DeletePlan',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/{planId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deletePlan.fromReq = fromReq;
    __deletePlan.__isAmbassador = true;
    return __deletePlan;
}
/** Query plans using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryPlans(payload) {
    var _a = serializer(_queryPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPlansResponse, { _plan: _plan }).fromJSON;
    function __queryPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'GET',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.QueryPlans',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                        protoPath: '/v3/plans/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryPlans.fromReq = fromReq;
    __queryPlans.__isAmbassador = true;
    return __queryPlans;
}
/** Search plans using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) with search capabilities */
export function searchPlans(payload) {
    var _a = serializer(_searchPlansRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchPlansResponse, { _plan: _plan }).fromJSON;
    function __searchPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'GET',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.SearchPlans',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                        protoPath: '/v3/plans/search',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __searchPlans.fromReq = fromReq;
    __searchPlans.__isAmbassador = true;
    return __searchPlans;
}
/** Count plans using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function countPlans(payload) {
    var _a = serializer(_countPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countPlansResponse, {}).fromJSON;
    function __countPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'POST',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.CountPlans',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countPlans.fromReq = fromReq;
    __countPlans.__isAmbassador = true;
    return __countPlans;
}
/** Updates extended fields of a Plan without incrementing revision */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _plan: _plan,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v3.plan',
            method: 'POST',
            methodFqn: 'wix.pricing_plans.plans.v3.PlanService.UpdateExtendedFields',
            url: resolveWixPricingPlansPlansV3PlanServiceUrl({
                protoPath: '/v3/plans/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
//# sourceMappingURL=http.impl.js.map